import request from '@/utils/request';

// 地址统计报表
export const getAddressStatistics = (params: any) =>
  request({
    url: 'StatisticsAddress/address',
    method: 'get',
    params
  });

// 导出excel 地址统计
export const exportAddressStatistics = (params: any) =>
  request({
    url: 'StatisticsAddress/export',
    method: 'get',
    params
  });
